/*
  Inner Botanica – The Letter: keepsake motifs.
  window.IB_PL_MOTIFS — self-contained SVG watercolor-style artwork used as a
  faint watermark behind the letter (screen, print, and PDF). No external
  assets, no licensing: hand-built line art over soft color washes in the
  brand palette. Each motif is a full standalone <svg> string at a 240×240
  viewBox; the app tints opacity and rasterizes for the PDF.

  CONTRACT: motif `id` values are encoded into shared ?k= links — permanent
  once live. Labels and artwork may change freely; ids must not be renamed.
*/
window.IB_PL_MOTIFS = (function () {
  "use strict";

  /* brand palette */
  var BLUSH = "#8a4a63", BLUSHD = "#6d2f4c",
      SAGE = "#7d9a3a", SAGED = "#5e7c21",
      SAND = "#cf9576", GOLD = "#d9a441", GOLDD = "#c07d1e",
      COPPER = "#b97727", TAN = "#9c6b3f",
      SLATE = "#4a6a6f";

  /* Shared header: a soft-blur filter ("wc" = watercolor wash) so filled
     shapes bleed softly beyond the linework. */
  function svg(inner) {
    return "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 240 240' fill='none' " +
      "stroke-linecap='round' stroke-linejoin='round'>" +
      "<defs><filter id='wc' x='-40%' y='-40%' width='180%' height='180%'>" +
      "<feGaussianBlur stdDeviation='6'/></filter></defs>" + inner + "</svg>";
  }
  function wash(shapes) { return "<g filter='url(#wc)' opacity='0.55'>" + shapes + "</g>"; }

  /* ---- heart path helper (tip down), centered on (0,0), scaled s ---- */
  function heart(cx, cy, s, stroke, fill) {
    var d = "M0 13 C -11 -7 -36 -5 -36 -23 C -36 -38 -17 -42 0 -25 " +
            "C 17 -42 36 -38 36 -23 C 36 -5 11 -7 0 13 Z";
    var g = "<g transform='translate(" + cx + " " + cy + ") scale(" + s + ")'>";
    if (fill) g += "<path d='" + d + "' fill='" + fill + "'/>";
    if (stroke) g += "<path d='" + d + "' stroke='" + stroke + "' stroke-width='" + (3 / s) + "'/>";
    return g + "</g>";
  }

  /* ---- five-petal bloom ---- */
  function bloom(cx, cy, r, petal, core) {
    var g = "<g transform='translate(" + cx + " " + cy + ")'>";
    for (var i = 0; i < 5; i++) {
      var a = (i * 72 - 90) * Math.PI / 180;
      var px = Math.cos(a) * r, py = Math.sin(a) * r;
      g += "<ellipse cx='" + px.toFixed(1) + "' cy='" + py.toFixed(1) + "' rx='" +
           (r * 0.62).toFixed(1) + "' ry='" + (r * 0.42).toFixed(1) +
           "' fill='" + petal + "' transform='rotate(" + (i * 72) + " " +
           px.toFixed(1) + " " + py.toFixed(1) + ")'/>";
    }
    g += "<circle r='" + (r * 0.42).toFixed(1) + "' fill='" + core + "'/></g>";
    return g;
  }

  /* ---- paw print ---- */
  function paw(cx, cy, s, rot, col) {
    return "<g transform='translate(" + cx + " " + cy + ") rotate(" + rot + ") scale(" + s + ")' fill='" + col + "'>" +
      "<ellipse cx='0' cy='9' rx='15' ry='12'/>" +
      "<ellipse cx='-12' cy='-7' rx='5' ry='7'/>" +
      "<ellipse cx='-4' cy='-14' rx='5' ry='7'/>" +
      "<ellipse cx='5' cy='-14' rx='5' ry='7'/>" +
      "<ellipse cx='12' cy='-7' rx='5' ry='7'/></g>";
  }

  /* ---- little cloud ---- */
  function cloud(cx, cy) {
    return "<g fill='#fdfaf3' stroke='" + SLATE + "' stroke-width='2'>" +
      "<ellipse cx='" + cx + "' cy='" + cy + "' rx='23' ry='13'/>" +
      "<circle cx='" + (cx - 10) + "' cy='" + (cy - 6) + "' r='11'/>" +
      "<circle cx='" + (cx + 9) + "' cy='" + (cy - 7) + "' r='13'/></g>";
  }

  /* ---- bird in flight (wings + little forked-tail body) ---- */
  function bird(cx, cy, s, col) {
    return "<g transform='translate(" + cx + " " + cy + ") scale(" + s + ")'>" +
      "<path d='M-24 2 Q -12 -18 0 -3 Q 12 -18 24 2' fill='none' stroke='" + col +
      "' stroke-width='" + (3.4 / s).toFixed(2) + "'/>" +
      "<path d='M0 -3 L 4 8 L 0 5 L -4 8 Z' fill='" + col + "'/></g>";
  }

  var MOTIFS = [
    { id: "none", label: "None", svg: "" },

    {
      id: "wildflowers", label: "Wildflowers",
      svg: svg(
        wash(
          "<ellipse cx='120' cy='120' rx='58' ry='70' fill='" + BLUSH + "' opacity='0.5'/>" +
          "<ellipse cx='95' cy='150' rx='40' ry='46' fill='" + SAGE + "' opacity='0.5'/>"
        ) +
        /* stems */
        "<g stroke='" + SAGED + "' stroke-width='3' fill='none'>" +
        "<path d='M120 208 C 116 170 118 130 120 96'/>" +
        "<path d='M120 208 C 100 176 90 140 84 108'/>" +
        "<path d='M120 208 C 140 178 152 146 158 116'/>" +
        "<path d='M108 168 C 96 160 88 162 82 154'/>" +
        "<path d='M132 158 C 146 152 152 154 160 146'/>" +
        "</g>" +
        /* leaves */
        "<g fill='" + SAGE + "'>" +
        "<ellipse cx='96' cy='166' rx='13' ry='6' transform='rotate(-28 96 166)'/>" +
        "<ellipse cx='146' cy='156' rx='13' ry='6' transform='rotate(24 146 156)'/>" +
        "</g>" +
        /* blooms */
        bloom(120, 88, 15, BLUSH, GOLD) +
        bloom(84, 100, 12, SAND, GOLD) +
        bloom(158, 108, 12, GOLD, BLUSH)
      )
    },

    {
      id: "roses", label: "Roses",
      svg: svg(
        wash("<circle cx='104' cy='104' r='40' fill='" + BLUSH + "'/>" +
             "<circle cx='150' cy='138' r='30' fill='" + SAND + "'/>") +
        /* stems + leaves */
        "<g stroke='" + SAGED + "' stroke-width='3' fill='none'>" +
        "<path d='M104 138 C 104 168 116 190 120 208'/>" +
        "<path d='M150 160 C 150 180 140 196 132 208'/>" +
        "<path d='M112 176 C 128 170 138 176 146 168'/>" +
        "</g>" +
        "<ellipse cx='134' cy='174' rx='13' ry='6' transform='rotate(20 134 174)' fill='" + SAGE + "'/>" +
        /* rose 1 (spiral) */
        "<g transform='translate(104 104)' stroke='" + BLUSHD + "' stroke-width='2.6' fill='none'>" +
        "<path d='M0 0 C 8 -6 14 4 6 10 C -6 18 -20 6 -14 -8 C -6 -24 18 -22 24 -4 C 30 16 8 34 -14 28'/>" +
        "<circle r='30' stroke='" + BLUSH + "' stroke-width='2.6'/></g>" +
        /* rose 2 */
        "<g transform='translate(150 138) scale(0.72)' stroke='" + GOLDD + "' stroke-width='3' fill='none'>" +
        "<path d='M0 0 C 8 -6 14 4 6 10 C -6 18 -20 6 -14 -8 C -6 -24 18 -22 24 -4 C 30 16 8 34 -14 28'/>" +
        "<circle r='30' stroke='" + SAND + "' stroke-width='3'/></g>"
      )
    },

    {
      id: "eucalyptus", label: "Eucalyptus sprig",
      svg: svg(
        wash("<ellipse cx='120' cy='118' rx='54' ry='72' fill='" + SAGE + "'/>") +
        "<path d='M120 210 C 112 168 124 128 120 84' stroke='" + SAGED + "' stroke-width='3' fill='none'/>" +
        (function () {
          var s = "";
          var pts = [[120, 90, -20], [120, 116, 22], [120, 142, -24], [120, 168, 26], [120, 190, -20]];
          for (var i = 0; i < pts.length; i++) {
            var p = pts[i], side = (i % 2 === 0) ? -1 : 1;
            var lx = p[0] + side * 22, ly = p[1] - 6;
            s += "<ellipse cx='" + lx + "' cy='" + ly + "' rx='17' ry='11' fill='" + SAGE +
                 "' opacity='0.9' transform='rotate(" + (side * 30) + " " + lx + " " + ly + ")'/>";
            var rx2 = p[0] - side * 22;
            s += "<ellipse cx='" + rx2 + "' cy='" + (p[1] + 8) + "' rx='15' ry='10' fill='" + SAGED +
                 "' opacity='0.75' transform='rotate(" + (-side * 30) + " " + rx2 + " " + (p[1] + 8) + ")'/>";
          }
          return s;
        })() +
        "<circle cx='120' cy='80' r='4' fill='" + GOLD + "'/>"
      )
    },

    {
      id: "hearts", label: "Hearts",
      svg: svg(
        wash(heart(120, 116, 1.9, null, BLUSH) +
             heart(84, 150, 1.1, null, SAND) +
             heart(158, 150, 1.0, null, GOLD)) +
        heart(120, 116, 1.9, BLUSHD, "none") +
        heart(84, 150, 1.1, BLUSHD, "none") +
        heart(158, 150, 1.0, GOLDD, "none")
      )
    },

    {
      id: "butterflies", label: "Butterflies",
      svg: svg(
        wash("<circle cx='96' cy='104' r='34' fill='" + BLUSH + "'/>" +
             "<circle cx='158' cy='150' r='26' fill='" + GOLD + "'/>") +
        /* butterfly 1 */
        "<g transform='translate(96 104)'>" +
        "<ellipse cx='-18' cy='-14' rx='18' ry='14' fill='" + BLUSH + "' opacity='0.85'/>" +
        "<ellipse cx='18' cy='-14' rx='18' ry='14' fill='" + BLUSH + "' opacity='0.85'/>" +
        "<ellipse cx='-14' cy='14' rx='13' ry='11' fill='" + SAND + "' opacity='0.85'/>" +
        "<ellipse cx='14' cy='14' rx='13' ry='11' fill='" + SAND + "' opacity='0.85'/>" +
        "<line x1='0' y1='-22' x2='0' y2='22' stroke='" + BLUSHD + "' stroke-width='3'/>" +
        "<path d='M0 -22 C -6 -32 -10 -34 -14 -34' stroke='" + BLUSHD + "' stroke-width='2' fill='none'/>" +
        "<path d='M0 -22 C 6 -32 10 -34 14 -34' stroke='" + BLUSHD + "' stroke-width='2' fill='none'/>" +
        "</g>" +
        /* butterfly 2 */
        "<g transform='translate(158 150) scale(0.72)'>" +
        "<ellipse cx='-18' cy='-14' rx='18' ry='14' fill='" + GOLD + "' opacity='0.85'/>" +
        "<ellipse cx='18' cy='-14' rx='18' ry='14' fill='" + GOLD + "' opacity='0.85'/>" +
        "<ellipse cx='-14' cy='14' rx='13' ry='11' fill='" + SAND + "' opacity='0.85'/>" +
        "<ellipse cx='14' cy='14' rx='13' ry='11' fill='" + SAND + "' opacity='0.85'/>" +
        "<line x1='0' y1='-22' x2='0' y2='22' stroke='" + GOLDD + "' stroke-width='3'/>" +
        "</g>"
      )
    },

    {
      id: "teddy", label: "Teddy bear",
      svg: svg(
        wash("<circle cx='120' cy='128' r='64' fill='" + SAND + "'/>") +
        "<g stroke='" + "#9c6b3f" + "' stroke-width='3' fill='" + SAND + "'>" +
        /* ears */
        "<circle cx='92' cy='78' r='16'/>" +
        "<circle cx='148' cy='78' r='16'/>" +
        /* head */
        "<circle cx='120' cy='100' r='30'/>" +
        /* body */
        "<ellipse cx='120' cy='158' rx='34' ry='38'/>" +
        /* arms */
        "<ellipse cx='84' cy='150' rx='13' ry='20' transform='rotate(24 84 150)'/>" +
        "<ellipse cx='156' cy='150' rx='13' ry='20' transform='rotate(-24 156 150)'/>" +
        /* legs */
        "<ellipse cx='100' cy='192' rx='15' ry='12'/>" +
        "<ellipse cx='140' cy='192' rx='15' ry='12'/>" +
        "</g>" +
        /* face */
        "<g fill='" + "#6d4326" + "'>" +
        "<circle cx='110' cy='98' r='3.4'/>" +
        "<circle cx='130' cy='98' r='3.4'/>" +
        "<ellipse cx='120' cy='108' rx='9' ry='7' fill='#efd9c2'/>" +
        "<circle cx='120' cy='106' r='3.2'/></g>"
      )
    },

    {
      id: "cat", label: "Sleeping cat",
      svg: svg(
        wash("<ellipse cx='120' cy='140' rx='70' ry='44' fill='" + SLATE + "'/>") +
        "<g stroke='#33474a' stroke-width='3' fill='" + SLATE + "'>" +
        /* curled body */
        "<path d='M64 150 C 52 116 84 92 120 92 C 168 92 196 128 184 158 " +
        "C 176 180 150 188 120 188 C 88 188 72 176 64 150 Z'/>" +
        /* head resting */
        "<circle cx='84' cy='150' r='26'/>" +
        /* ears */
        "<path d='M66 134 L 60 116 L 80 126 Z'/>" +
        "<path d='M100 128 L 106 110 L 112 130 Z'/>" +
        /* tail curling around */
        "<path d='M184 156 C 200 156 206 174 190 182 C 178 188 168 182 166 176' fill='none'/>" +
        "</g>" +
        /* sleeping face + zzz */
        "<g stroke='#2a3a3c' stroke-width='2.6' fill='none'>" +
        "<path d='M72 150 C 76 154 82 154 86 150'/>" +
        "<path d='M92 150 C 96 154 102 154 106 150'/>" +
        "</g>" +
        "<g fill='#33474a' font-family='sans-serif' font-style='italic'>" +
        "<text x='150' y='74' font-size='16'>z</text>" +
        "<text x='166' y='60' font-size='20'>z</text></g>"
      )
    },

    {
      id: "moon_stars", label: "Moon & stars",
      svg: svg(
        wash("<circle cx='128' cy='112' r='46' fill='" + GOLD + "'/>") +
        /* crescent = big circle minus offset circle */
        "<path d='M150 74 A 46 46 0 1 0 150 150 A 36 36 0 1 1 150 74 Z' fill='" + GOLD + "' opacity='0.9'/>" +
        "<path d='M150 74 A 46 46 0 1 0 150 150 A 36 36 0 1 1 150 74 Z' fill='none' stroke='" + GOLDD + "' stroke-width='2.5'/>" +
        /* sparkle stars */
        (function () {
          function star(cx, cy, r, col) {
            return "<path d='M" + cx + " " + (cy - r) + " C " + cx + " " + (cy - r * 0.25) + " " +
              (cx + r * 0.25) + " " + cy + " " + (cx + r) + " " + cy + " C " +
              (cx + r * 0.25) + " " + cy + " " + cx + " " + (cy + r * 0.25) + " " + cx + " " + (cy + r) + " C " +
              cx + " " + (cy + r * 0.25) + " " + (cx - r * 0.25) + " " + cy + " " + (cx - r) + " " + cy + " C " +
              (cx - r * 0.25) + " " + cy + " " + cx + " " + (cy - r * 0.25) + " " + cx + " " + (cy - r) + " Z' fill='" + col + "'/>";
          }
          return star(78, 96, 15, BLUSH) + star(96, 150, 10, SAND) +
                 star(160, 176, 12, GOLD) + star(186, 120, 8, BLUSH);
        })()
      )
    },

    {
      id: "sunflower", label: "Sunflower",
      svg: svg(
        wash("<circle cx='120' cy='104' r='52' fill='" + GOLD + "'/>") +
        "<path d='M120 152 C 118 176 120 196 122 210' stroke='" + SAGED + "' stroke-width='3.5' fill='none'/>" +
        "<ellipse cx='98' cy='178' rx='16' ry='9' transform='rotate(-24 98 178)' fill='" + SAGE + "'/>" +
        "<ellipse cx='144' cy='188' rx='16' ry='9' transform='rotate(22 144 188)' fill='" + SAGE + "'/>" +
        /* petals */
        (function () {
          var s = "<g transform='translate(120 104)'>";
          for (var i = 0; i < 14; i++) {
            var a = i * (360 / 14);
            s += "<ellipse cx='0' cy='-40' rx='8' ry='18' fill='" + GOLD +
                 "' stroke='" + GOLDD + "' stroke-width='1.5' transform='rotate(" + a + ")'/>";
          }
          return s + "</g>";
        })() +
        "<circle cx='120' cy='104' r='22' fill='#7a4a1e'/>" +
        "<circle cx='120' cy='104' r='22' fill='none' stroke='#5e3714' stroke-width='2'/>"
      )
    },

    {
      id: "dog", label: "Dog",
      svg: svg(
        wash("<circle cx='120' cy='134' r='60' fill='" + SAND + "'/>") +
        "<g stroke='" + TAN + "' stroke-width='3' fill='" + SAND + "'>" +
        /* ears behind head */
        "<ellipse cx='90' cy='110' rx='13' ry='30' transform='rotate(16 90 110)'/>" +
        "<ellipse cx='150' cy='110' rx='13' ry='30' transform='rotate(-16 150 110)'/>" +
        /* body */
        "<ellipse cx='120' cy='168' rx='32' ry='34'/>" +
        /* head */
        "<circle cx='120' cy='106' r='32'/>" +
        /* front paws */
        "<ellipse cx='104' cy='196' rx='12' ry='11'/>" +
        "<ellipse cx='136' cy='196' rx='12' ry='11'/>" +
        /* tail */
        "<path d='M150 172 C 174 164 180 182 166 190' fill='none'/>" +
        "</g>" +
        /* snout + face */
        "<ellipse cx='120' cy='118' rx='15' ry='12' fill='#efd9c2' stroke='" + TAN + "' stroke-width='2'/>" +
        "<g fill='#5a3a20'>" +
        "<circle cx='109' cy='102' r='3.4'/>" +
        "<circle cx='131' cy='102' r='3.4'/>" +
        "<circle cx='120' cy='112' r='4.4'/></g>" +
        "<path d='M120 116 L 120 122' stroke='#5a3a20' stroke-width='2'/>"
      )
    },

    {
      id: "paws", label: "Paw prints",
      svg: svg(
        wash("<ellipse cx='120' cy='120' rx='58' ry='68' fill='" + BLUSH + "'/>") +
        paw(84, 72, 1.0, -18, BLUSH) +
        paw(150, 98, 0.95, 14, SAND) +
        paw(92, 142, 1.05, -10, SAGE) +
        paw(158, 168, 0.95, 16, GOLD) +
        paw(112, 196, 1.0, -6, BLUSHD)
      )
    },

    {
      id: "sun", label: "Sunshine",
      svg: svg(
        wash("<circle cx='120' cy='118' r='58' fill='" + GOLD + "'/>") +
        "<g transform='translate(120 118)'>" +
        (function () {
          var s = "";
          for (var i = 0; i < 12; i++) {
            s += "<line x1='0' y1='-46' x2='0' y2='-64' stroke='" + GOLDD +
                 "' stroke-width='5' transform='rotate(" + (i * 30) + ")'/>";
          }
          return s;
        })() +
        "</g>" +
        "<circle cx='120' cy='118' r='40' fill='" + GOLD + "' stroke='" + GOLDD + "' stroke-width='3'/>"
      )
    },

    {
      id: "rainbow", label: "Rainbow",
      svg: svg(
        wash("<ellipse cx='120' cy='150' rx='74' ry='42' fill='" + SAND + "'/>") +
        "<g fill='none' stroke-width='10'>" +
        "<path d='M50 168 A 70 70 0 0 1 190 168' stroke='" + BLUSH + "'/>" +
        "<path d='M62 168 A 58 58 0 0 1 178 168' stroke='" + SAND + "'/>" +
        "<path d='M74 168 A 46 46 0 0 1 166 168' stroke='" + GOLD + "'/>" +
        "<path d='M86 168 A 34 34 0 0 1 154 168' stroke='" + SAGE + "'/>" +
        "</g>" +
        cloud(54, 172) + cloud(186, 172)
      )
    },

    {
      id: "coffee", label: "Coffee",
      svg: svg(
        wash("<circle cx='120' cy='134' r='54' fill='" + SAND + "'/>") +
        "<g stroke='" + SLATE + "' stroke-width='3' fill='none' opacity='0.7'>" +
        "<path d='M106 98 C 98 90 114 82 106 72'/>" +
        "<path d='M126 98 C 118 90 134 82 126 72'/>" +
        "</g>" +
        "<ellipse cx='120' cy='184' rx='48' ry='10' fill='#f0e6d8' stroke='" + COPPER + "' stroke-width='3'/>" +
        "<path d='M82 118 L 158 118 L 150 170 Q 120 182 90 170 Z' fill='#f4ecdf' stroke='" + COPPER + "' stroke-width='3'/>" +
        "<path d='M158 128 C 182 128 182 156 156 156' fill='none' stroke='" + COPPER + "' stroke-width='3'/>" +
        "<ellipse cx='120' cy='120' rx='36' ry='6' fill='#7a4a1e'/>"
      )
    },

    {
      id: "birds", label: "Little birds",
      svg: svg(
        wash("<ellipse cx='100' cy='96' rx='40' ry='26' fill='" + SAND + "'/>" +
             "<ellipse cx='152' cy='142' rx='30' ry='20' fill='" + BLUSH + "'/>") +
        bird(96, 92, 1.9, "#39535a") +
        bird(158, 132, 1.4, BLUSHD) +
        bird(122, 172, 1.05, "#39535a")
      )
    }
  ];

  return MOTIFS;
})();
